import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import awaitMandarkQueries from 'lib/hocs/awaitMandarkQueries';
import {resource} from '@albert-io/json-api-framework/request/builder';
import {Link} from 'react-router';
import {Modal, Dialogue, Text, Button, SelectField} from '@albert-io/atomic';

export const CreateAssessmentModal = ({handleClose, subjects}) => {
  const [selectedSubject, setSelectedSubject] = useState();
  useEffect(() => {
    setSelectedSubject(subjects.first().getUrlSlug());
  }, [subjects]);
  return (
    <Modal handleClose={handleClose}>
      {({modalContentStyle}) => {
        return (
          <Dialogue
            inModal
            title='Assign Assessment'
            className={modalContentStyle}
            handleClose={handleClose}
          >
            <Dialogue.Body>
              <Text as='p' emphasis='lowest'>
                Choose a subject below to get started.
              </Text>
              <SelectField
                className='u-mar-b_2'
                border
                label='Select Subject'
                options={subjects.map((subject) => ({
                  label: subject.getName(),
                  value: subject.getUrlSlug()
                }))}
                onChange={(e) => {
                  setSelectedSubject(e.target.value);
                }}
              />
              <Button className='u-width_100pc' as={Link} to={`/${selectedSubject}/assessments`}>
                Go to Assessments Guide
              </Button>
            </Dialogue.Body>
          </Dialogue>
        );
      }}
    </Modal>
  );
};

export default awaitMandarkQueries(
  ({classroomId}) => ({
    queries: {
      subjects: resource('subjects_v2')
        .mandarkEndpoint(['classrooms_v1', classroomId, 'subjects_v2'])
        .include('guides_v1')
        .sort('name')
        .pageSize('infinite')
        .filter({
          guides_v1: {
            guide_type: 'assessment'
          }
        })
    },
    loadingElement: null
  }),
  CreateAssessmentModal
);

CreateAssessmentModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  subjects: PropTypes.any
};
